import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import webServices from "../../../services/webServices";
import { useSelector } from "react-redux";
import AdminSidebar from "../../layouts/AdminSidebar";
import RestaurantDetailPage from "../../common/RestaurantDetailPage";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";

function UpdateRestaurantDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { restaurantId, actiontype, actionrestCat } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(false);
  const { current } = useSelector((state) => state.user);

  const buttons = [{ id: 1, label: "Update", type: "breakFast" }];

  useEffect(() => {
    if (!restaurantId) {
      navigate(AppConstants.routes.admin.restaurantEditListing);
    }

    async function fetchData() {
      const resp = await authCall("getCompanyDetails", {
        companyId: restaurantId,
        companyType: "Restaurant",
      });
      if (resp?.type === "success") {
        setCompanyDetails(resp?.payload);
      }
    }
    fetchData();
  }, []);

  const handleSubmit = async (data, val) => {
    setLoading(true);
    const resp = await webServices.createRestaurant(data);
    if (resp?.type === "success") {
      setLoading(false);
      toast.dismiss();

      toast.success("Updated successfully.");
      if (current?.user_type === "Admin") {
        if (!actiontype) {
          navigate(AppConstants.routes.admin.restaurantList);
        } else {
          navigate(
            `${AppConstants.routes.admin.tags}?type=${actiontype}&restCat=${actionrestCat}`
          );
        }
      } else {
        navigate(AppConstants.routes.admin.restaurantEditListing);
      }
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <RestaurantDetailPage
        onSubmit={handleSubmit}
        loading={loading}
        details={companyDetails}
        heading="Update Restaurant Details"
        Sidebar={AdminSidebar}
        buttons={buttons}
      />
    </>
  );
}

export default UpdateRestaurantDetails;
